import formatNumber from './format-number';

export default (value: number): string => {
  // 8000 -> 8k bu
  const formattedVal: String = formatNumber(Math.round(value / 1000));
  return `${formattedVal}k bu`;
};
